import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const EmptyMessage: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="center"
      sx={{
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="center"
        sx={{
          fontStyle: 'italic',
          opacity: 0.8,
        }}
      >
        {t('hotelContent.nimbuxHotels.noMoreHotels')}
      </Typography>
    </Box>
  );
};
